<template>
<div v-if="!isLoading">

	<!--
	<lang labelKey="MSG-ERROR-USER-USERNAME_TOO_SHORT"></lang>
-->
	<div class="page-header">
		<h1>
			<template v-if="!isNewUser">{{ headTitle }}</template>
			<template v-else><lang labelKey="HEADLINE_NEW_USER"></lang></template>
		</h1>
	</div>

	<template v-if="!isLoading">

		<div class="columns">

			<div class="col-main">

				<form @submit.prevent="validateBeforeSubmit">

					<tabs type="boxed" size="normal">

						<tab-item label="Stammdaten">

							<div class="control is-horizontal">
								<div class="control-label">
									<label-name labelKey="PRODUCT-UPLOAD_FILE_BOX"></label-name>
								</div>
								<div class="control">

									<vue-dropzone
										ref="vueDropzone"
										id="vueDropzone"
										url= "fileProcessing/upload?preset=person"
										:maxFiles="1"
										:thumbnailWidth="100"
										:thumbnailHeight="100"
										acceptedFiles= ".jpg,.jpeg,.png,.gif"
										:dictDefaultMessage="`<i class='fa fa-cloud-upload'></i>` + $t('USER_ACCOUNT-UPLOAD_AVATAR')"
										v-on:vdropzone-removed-file="dzAvatarRemoveFile"
										v-on:vdropzone-mounted="dzAvatarInit"
										v-on:vdropzone-success="dzAvatarSuccess">
									</vue-dropzone>

								</div>
							</div>

							<div class="control is-horizontal">
								<div class="control-label">
									<label-name labelKey="USER_USERNAME"></label-name>
								</div>
								<div class="control">
									<input id="USER_USERNAME" class="input is-medium" type="text" v-model.trim="user.username">
								</div>
							</div>

							<div class="control is-horizontal">
								<div class="control-label">
									<label-name labelKey="USER_FIRSTNAME"></label-name>
								</div>
								<div class="control">
									<input id="USER_FIRSTNAME" class="input is-medium" type="text" v-model.trim="user.person.firstname">
								</div>
							</div>

							<div class="control is-horizontal">
								<div class="control-label">
									<label-name labelKey="USER_LASTNAME"></label-name>
								</div>
								<div class="control">
									<input id="USER_LASTNAME" class="input is-medium" type="text" v-model.trim="user.person.lastname">
								</div>
							</div>

							<div class="control is-horizontal">
								<div class="control-label">
									<label-name labelKey="USER_EMAIL"></label-name>
								</div>
								<div class="control">
									<input id="USER_EMAIL" class="input is-medium" type="text" v-model.trim="user.email">
								</div>
							</div>

							<div class="control is-horizontal">
								<div class="control-label">
									<label-name labelKey="USER_SIGNATURE"></label-name>
								</div>
								<div class="control">
									<textarea id="USER_SIGNATURE" class="textarea is-medium" type="text" v-model.trim="user.emailSignature"></textarea>
								</div>
							</div>

							<br />

							<div class="control is-horizontal">
								<div class="control-label">
									<label-name labelKey="USER_USERGROUPS"></label-name>
								</div>
								<div class="control">
									<multiselect
										v-model="user.groups"
										:options="userGroups"
										label="name"
										deselect-label="Klick um abzuwählen"
										selectLabel="Klick um auszuwählen"
										selectedLabel="ausgewählt"
										:placeholder="$t('SELECT_BOX-USER-USERGROUP-PLEASE_SELECT')"
										:multiple="true"
										:close-on-select="true"
										:clear-on-select="false"
										:hide-selected="true"
										:preserve-search="false"
										track-by="name"
										class="tagging">
									</multiselect>
								</div>
							</div>

							<br />

							<div class="control is-horizontal">
								<div class="control-label">
									<label-name labelKey="USER_ROLE"></label-name>
								</div>
								<div class="control">
									<multiselect
										v-model="user.userRole"
										:options="userRoles"
										label="name"
										deselect-label="Klick um abzuwählen"
										selectLabel="Klick um auszuwählen"
										selectedLabel="ausgewählt"
										:placeholder="$t('SELECT_BOX-USER-PHARMACY-PLEASE_SELECT')"
										:multiple="false"
										:close-on-select="true"
										:clear-on-select="false"
										:hide-selected="true"
										:preserve-search="false"
										track-by="id"
										class="tagging">
									</multiselect>
								</div>
							</div>

							<div class="control is-horizontal" v-if="user.manufacturer != null || user.site != null">
								<div class="control-label">
									<label-name></label-name>
								</div>
								<div class="control">
									<template v-if="user.manufacturer != null">
										<!-- <input class="input is-medium is-disabled" type="text" v-model="user.manufacturer.name"> -->
										{{ user.manufacturer.name }}
									</template>
									<template v-else-if="user.site != null">
										<!-- <input class="input is-medium is-disabled" type="text" v-model="user.site.name"> -->
										{{ user.site.name }}
									</template>
								</div>
							</div>

							<br />
							<div class="control is-horizontal">
								<div class="control-label">
									<label-name labelKey="USER_PHARMACIES"></label-name>
								</div>
								<div class="control">
									<multiselect
										v-model="userPharmacies"
										:options="pharmacies"
										label="name"
										:custom-label="pharmacyLabelName"
										deselect-label="Klick um abzuwählen"
										selectLabel="Klick um auszuwählen"
										selectedLabel="ausgewählt"
										:placeholder="$t('SELECT_BOX-USER-PHARMACY-PLEASE_SELECT')"
										:multiple="true"
										:close-on-select="true"
										:clear-on-select="false"
										:hide-selected="true"
										:preserve-search="false"
										track-by="name"
										class="tagging">
									</multiselect>
								</div>
							</div>

							<br />

							<div class="control is-horizontal">
								<div class="control-label">
									<label-name labelKey="ACCOUNT_PASSWORD"></label-name>
								</div>
								<div class="control">
									<input id="ACCOUNT_PASSWORD" v-model.trim="pass1" type="password" placeholder="Passwort" class="input is-medium">
									<!-- <i class="fa fa-warning"></i> -->
								</div>
							</div>

							<div class="control is-horizontal">
								<div class="control-label"></div>
								<div class="control">
									<input id="ACCOUNT_PASSWORD2" v-model.trim="pass2" type="password" placeholder="Passwort wiederholen" class="input is-medium">
									<!-- <i class="fa fa-warning"></i> -->
								</div>
							</div>

							<template v-if="activeUser.admin">

								<br>
								<div class="control is-horizontal">

									<div class="control-label">
										<label-name labelKey="USER_LANDING_PAGE"></label-name>
									</div>
							
									<div class="control">
										<multiselect
											:options="defaultRoutes"
											v-model="user._defaultRoute"
											label="name"
											deselect-label="Klick um abzuwählen"
											selectLabel="Klick um auszuwählen"
											selectedLabel="ausgewählt"
											:placeholder="$t('SELECT_BOX-USER-USERGROUP-PLEASE_SELECT')"
											:multiple="false"
											:close-on-select="true"
											:clear-on-select="false"
											:hide-selected="false"
											:preserve-search="false"
											track-by="name"
											:allow-empty="true">

											<template slot="singleLabel" slot-scope="props">{{ props.option.name }}</template>

											<template slot="option" slot-scope="props">

												<div class="option__desc">
													<span class="option__title">{{ props.option.name }}</span>
													<span class="option__small">{{ props.option.path }}</span>
												</div>
											</template>

										</multiselect>

									</div>

								</div>

							</template>

							<br />

							<div class="control is-horizontal">
								<div class="control-label">
									<label-name labelKey="ACCOUNT_LAST_LOGIN"></label-name>
								</div>
								<div class="control">

									<template v-if="user.lastLoginDate == null">
										--
									</template>
									<template v-else>
										{{ formatDate2(user.lastLoginDate) }}
									</template>

								</div>

							</div>

						</tab-item>

					</tabs>

				</form>

			</div> <!-- // col-main -->


			<div class="col-aside">

				<affix :offset="50">
					<div class="sidebox">
						<!-- <custom-button type="blue" icon="fa-save" name="USER_BUTTON_SAVE" :loading="isSaving" @click.native="submitForm"></custom-button> -->
						<custom-button type="blue" icon="icon-ak-speichern" name="USER_BUTTON_SAVE" :loading="isSaving" @click.native="validateBeforeSubmit()"></custom-button>
					</div>
				</affix>

			</div>

		</div> <!-- // columns -->

	</template>

</div>

</template>


<script>
import vue2Dropzone from '../utils/dropzoneWrapper'

export default {

	name: 'user',

	components: {
		vueDropzone: vue2Dropzone,
	},

	data() {

		return {
			defaultRoutes: [],
			isNewUser: false,
			user: {},
			userRoles: [],
			userGroups: [],
			pharmacies: null,
			isSaving: false,
			isLoading: false,
			pass1: '',
			pass2: '',

			langOptions: [
				{ text: 'Deutsch', value: 'de' },
				{ text: 'Englisch', value: 'en' },
				{ text: 'Französisch', value: 'fr' },
				{ text: 'Französisch', value: 'it' }
			],

		}
	},

  computed: {

		headTitle() {

			if(this.user.person.firstname && this.user.person.firstname != "" && this.user.person.lastname && this.user.person.lastname != "") {
				return this.user.person.firstname + " " + this.user.person.lastname;
			} else {
				return this.user.username;
			}
		},

		/*
		userRole: {

			get() {
				return this.userRoles.find((r) => r.id == this.user.userRole);
			},

			set(val) {
				console.log("val: ", val);

				if(val.length == 0) {
					return;
				}

				this.user.userRole = this.userRoles.find((r) => r.id == val);

			}
		},
		*/


		// https://github.com/shentao/vue-multiselect/issues/385
		userPharmacies: {

			get() {
				return this.user.sitesHelper.map(_ => this.pharmacies.find(p => p.id == _.site));
			},

			set(val) {
				this.user.sitesHelper = [];
				if(val.length == 0) {
					return;
				}
				val.forEach(_ =>  {
					this.user.sitesHelper.push({
						usr: this.user.id || null,
						site: _.id
					})
				})

			}
		},
	},

	created() {

		if(this.activeUser.admin) {
			this.prepareDefaultRoutes(this.$router.options.routes);
		}

		// fetch the USER ID from router
		if(this.$route.params.userID && Number.isInteger(parseInt(this.$route.params.userID)) )
		{
			this.isNewUser = false;
			this.fetchData();
		}
		// new user
		else
		{

			this.isLoading = true;
			this.isNewUser = true;

			// create new user obj
			this.user = {
				'admin': false,
				'enabled': true,
				'username': '',
				'email': '',
				'groups': [],
				'sites': [],
				'sitesHelper': [],
				'person': {
					'firstname': '',
					'lastname': ''
				},
				'_defaultRoute': null,
			}

			this.fetchMandatory();

		}

	},

	mounted() {


	},

	methods: {


		prepareDefaultRoutes(routes) {

			routes.forEach((route) => {

				if(route.children) {
					this.prepareDefaultRoutes(route.children);
				} else {
					if(route.meta && route.meta.suitableDefaultRoute) {
						this.defaultRoutes.push(route);
					}
				}

		});

		},

		pharmacyLabelName({name, extRef }) {
			return name + ' (#'+extRef+')';
		},

		// dropzone avatar handling
		// ---------------------------------------------------------------------
		dzAvatarInit() {

			if(this.user.person && this.user.person.image != null) {

				var url = this.$config.assets + this.user.person.image.path + '/' + this.user.person.image.filename;
				var mockFile = { id: 'avatar', name: this.user.person.image.filename, type: "image/*", size: 123 }

				// add mockFile to our dropzone
				this.$refs.vueDropzone.$children[0].manuallyAddFile(mockFile, url);

			}

		},

		dzAvatarSuccess(file) {

			var result = JSON.parse(file.xhr.response);

			this.user.person.image = {
				filename: result.fileName,
				path: result.dir,
				uploadFilename: file.name
			}

			// var self = this;
			// this.$refs.vueDropzone.removeAllFiles()
			// this.dzInit();

		},

		dzAvatarRemoveFile() {

			this.user.person.image = null;

		},



		validateBeforeSubmit() {

			// check for empty fields
			if(this.isNewUser) {

				if(this.user.username == ""
					|| this.user.email == ""
					|| this.pass1 == ""
					|| this.pass2 == ""
					|| this.user.userRole == "") {
						this.$notify.open({content: this.$t('MSG-ERROR-USER-NEW_USER-MISSING_FIELDS'), type: 'warning'});
						return false;
					}

					// check if passwords match
					if(this.pass1 != this.pass2)
					{
						this.$notify.open({content: this.$t('MSG-ERROR-USER-PASSWORDS_NOT_MATCHING'), type: 'warning'});
						return false;
					}
					else
					{
						this.user.newPassword = this.pass1;
					}

			} else {

				if(this.user.username == ""
					|| this.user.email == ""
					|| this.user.userRole == "") {
						this.$notify.open({content: this.$t('MSG-ERROR-USER-EXISTING_USER-MISSING_FIELDS'), type: 'warning'});
						return false;
					}

			}

			// username too short
			if(this.user.username.length < 2) {
				this.$notify.open({content: this.$t('MSG-ERROR-USER-USERNAME_TOO_SHORT'), type: 'warning'});
				return false;
			}

			// validate username
			var usernameRegex = /^[a-zA-ZäöüÄÖÜß0-9\-\_\.]+$/
			var validUsername = this.user.username.match(usernameRegex);

			if(validUsername == null){
				this.$notify.open({content: this.$t('MSG-ERROR-USER-USERNAME_NOT_VALID'), type: 'warning'});
				return false;
			}

			// validate email
			// var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		    // if(!re.test(this.user.email)) {
			if(!this.validateEmail(this.user.email)) {
				this.$notify.open({content: this.$t('MSG-ERROR-USER-EMAIL_NOT_VALID'), type: 'warning'});
				return false;
			}

			if(this.pass1) {

				// validate password length
				if(this.pass1.length <= 2) {
					this.$notify.open({content: this.$t('MSG-ERROR-USER-PASSWORD_TOO_SHORT'), type: 'warning'});
					return false;
				}
				/*
				// validate password
				if(!this.validatePassword(this.pass1)) {
					this.$notify.open({content: this.$t('MSG-ERROR-USER-PASSWORD_NOT_ALLOWED'), type: 'warning'});
					return false;
				}
				*/

			}

			// move on to formSubmit
			this.submitForm();

		},


		submitForm() {

			this.isSaving = true;
			var self = this;


			// UPDATE an existing user
			if(!this.isNewUser)	{

				this.user.sites = [];

				// if there were pharmacies assigned
				if(this.user.sitesHelper.length > 0)  {

					this.user.sitesHelper.forEach(_ =>  {
						this.user.sites.push({
							usr: this.user.id,
							site: _.site
						})
					})

				}

				
				// console.log("beforeSave: ", this.user._defaultRoute);

				// save defaultRoute
				this.user.defaultRoute = this.user._defaultRoute ? this.user._defaultRoute.name : null;

				// if there was a group selected, assign the user id
				if(this.user.groups.length > 0) {

					this.user.groups.forEach(g => {
						g.usr = this.user.id
					})

				}

				var apiURL = this.$config.api + 'user/'+this.$route.params.userID;

				this.axios.put(apiURL, this.user)
					.then(function(response) {

						self.isSaving = false;
						self.$notify.success({content: self.$t('MSG-SUCCESS-DATA_SAVE') });

					}).catch(function(error) {

						self.isSaving = false;
						this.$notify.open({content: self.$t('MSG-ERROR-DATA_SAVE') + ': ' + error.message, type: 'danger'});

					});

			}

			// INSERT a new user
			else
			{
				var apiURL = this.$config.api + 'user?include=user.userRole,userRole.defaultRoute';
				// this.user.password = this.pass1;

				this.axios.post(apiURL, this.user)
					.then(function(response) {


						let uid = response.data.id;
						self.user.id = uid;

						self.isNewUser = false;

						// if there were pharmacies assigned
						if(self.user.sitesHelper.length > 0)  {

							self.user.sitesHelper.forEach(_ =>  {
								self.user.sites.push({
									usr: uid,
									site: _.id
								})
							})

						}

						if(self.user.groups.length > 0) {

							self.user.groups.forEach(g => {
								g.usr = uid
							})
						}


						self.axios.put( self.$config.api + 'user/'+uid, self.user)
							.then(function(response) {
								self.isSaving = false;
								self.$notify.success({content: self.$t('MSG-SUCCESS-DATA_SAVE') });
							});


					}).catch(function(error) {

						self.isSaving = false;
						self.$notify.open({content: self.$t('MSG-ERROR-DATA_SAVE') + ': ' + error.message, type: 'danger'});

					});

			}

		},


		fetchData() {


			this.isLoading = true;
			var self = this;

			// get user
			function getUser() {
				return self.axios.get(self.$config.api + 'user/'+self.$route.params.userID+'?include=user.person,person.image,user.manufacturer,user.site,user.groups,user.sites,user.userRole,userRole.defaultRoute');
			}

			// get userRoles
			function getUserRoles() {
				return self.axios.get(self.$config.api + 'userRole');
			}

			// get pharmacies
			function getPharmacies() {
				return self.axios.get(self.$config.api + 'site?fields=name,mandate,extRef&orderBy=name');
			}

			this.axios.all([getUser(), getUserRoles(), getPharmacies()])

				.then(self.axios.spread(function (user, userRoles, pharmacies) {

					self.pharmacies = pharmacies.data.site;
					self.userRoles = userRoles.data.userRole;
					
					user.data.sitesHelper =  [];

					if(user.data.sites.length > 0) {

						user.data.sites.forEach((s) => {

							user.data.sitesHelper.push({
								usr: s.usr,
								site: s.site
							})

						})
					}

					// if person is null, create empty object
					if(user.data.person == null) {

						user.data.person = {
							firstname: '',
							lastname: ''
						}

					}

					// set default route object
					user.data._defaultRoute = self.defaultRoutes.find((r) => (r.path === user.data.defaultRoute || (r.name && r.name === user.data.defaultRoute))) || null;

					// assign user data
					self.user = user.data;

					let groupApiUrl = self.$config.api + 'group';

					if(self.userRole != 'Administrator') {	// if user is NOT Administrator
						groupApiUrl += '?filters[id]=5,7'
					}

					// get userGroups
					self.axios.get(groupApiUrl).then(response => {

						response.data.group.forEach(g => {
							self.userGroups.push({
								'name': g.name,
								'grp': g.id,
							})

						})

		
						if(self.user.groups.length > 0) {

							self.user.groups.forEach(ugroup => {
								let foundIndex = response.data.group.findIndex((g) => g.id == ugroup.grp);
								if(foundIndex > -1) {
									ugroup.name = response.data.group[foundIndex]['name'];
								} else {
									ugroup.name = 'group not found';
								}
							})

						}

						self.isLoading = false;
					})

				})).catch(function(error) {

					self.isLoading = false;
					console.log('Error: ', error.message);

				});

				
		},

		fetchMandatory() {

			this.isLoading = true;
			var self = this;

			// get userRoles
			function getUserRoles() {
				return self.axios.get(self.$config.api + 'userRole');
			}

			// get userGroups
			function getUserGroups() {
				return self.axios.get(self.$config.api + 'group?filters[id]=5,7')
			}

			// get pharmacies
			function getPharmacies() {
				return self.axios.get(self.$config.api + 'site?fields=name,id?orderBy=name');
			}

			// make the request
			this.axios.all([getUserRoles(), getUserGroups(), getPharmacies()])

				.then(self.axios.spread(function (userRoles, userGroups, pharmacies) {

					self.pharmacies = pharmacies.data.site;
					self.userRoles = userRoles.data.userRole;

					userGroups.data.group.forEach(g => {
						self.userGroups.push({
							'name': g.name,
							'grp': g.id,
						})
					})

					self.isLoading = false;

				})).catch(function(error) {

					self.isLoading = false;
					console.log('Error: ', error.message);

				});


		}


	}

}
</script>

<style scoped>


>>> .tagging .multiselect__tag {
	position: relative;
	display: inline-block;
	margin: 0 3px 0 0;
	border-radius: 3px;
	line-height: 1;
	background: #eaeaea;
	color: #222;
	white-space: nowrap;
	overflow: hidden;
	max-width: 100%;
	text-overflow: ellipsis;
	text-align: center;
	font-size: 12px;
	padding: 4px 8px;
	padding-right: 20px;
}

>>> .tagging .multiselect__tag-icon {

}
>>> .tagging .multiselect__tag-icon:after{
	color: black;
	transition: color .3s ease;
}
>>> .tagging .multiselect__tag-icon:hover:after{
	color: red;
}
>>> .tagging .multiselect__tag-icon:focus,
>>> .tagging .multiselect__tag-icon:hover {
	background: none !important;
	color: red;
}


>>> .tagging .multiselect__tags-wrap {
	white-space: pre-wrap;
}

>>> .tagging .multiselect__tag.disabled {
	background: #eaeaea;
	color: #bbb;
}


.option__desc {
	display: block;
}
.option__desc .option__title {
	display: block;
}
.option__desc .option__small {
	display: block;
	margin-top: 4px;
	font-size: 12px;
	color: #888;
}

</style>
